"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DURING_SCHOOL_YEAR: 'During school year',
    DURING_SCHOOL_BREAK: 'During school break',
    YEAR_ROUND: 'Year-round',
};
//# sourceMappingURL=ecParticipationPeriod.js.map